import { __makeTemplateObject, __read } from "tslib";
import React, { useCallback, useState } from 'react';
import { ContextMenu } from '../ContextMenu/ContextMenu';
import { useTheme } from '../../themes/ThemeContext';
import { stylesFactory } from '../../themes/stylesFactory';
import { getEdgeFields, getNodeFields } from './utils';
import { css } from 'emotion';
/**
 * Hook that contains state of the context menu, both for edges and nodes and provides appropriate component when
 * opened context menu should be opened.
 */
export function useContextMenu(getLinks, nodes, edges) {
    var _a = __read(useState(undefined), 2), openedNode = _a[0], setOpenedNode = _a[1];
    var onNodeOpen = useCallback(function (event, node) { return setOpenedNode({ node: node, event: event }); }, []);
    var _b = __read(useState(undefined), 2), openedEdge = _b[0], setOpenedEdge = _b[1];
    var onEdgeOpen = useCallback(function (event, edge) { return setOpenedEdge({ edge: edge, event: event }); }, []);
    var MenuComponent = null;
    if (openedNode) {
        var items = getItems(getLinks(nodes, openedNode.node.dataFrameRowIndex));
        if (items.length) {
            MenuComponent = (React.createElement(ContextMenu, { renderHeader: function () { return React.createElement(NodeHeader, { node: openedNode.node, nodes: nodes }); }, items: items, onClose: function () { return setOpenedNode(undefined); }, x: openedNode.event.pageX, y: openedNode.event.pageY }));
        }
    }
    if (openedEdge) {
        var items = getItems(getLinks(edges, openedEdge.edge.dataFrameRowIndex));
        if (items.length) {
            MenuComponent = (React.createElement(ContextMenu, { renderHeader: function () { return React.createElement(EdgeHeader, { edge: openedEdge.edge, edges: edges }); }, items: items, onClose: function () { return setOpenedEdge(undefined); }, x: openedEdge.event.pageX, y: openedEdge.event.pageY }));
        }
    }
    return { onEdgeOpen: onEdgeOpen, onNodeOpen: onNodeOpen, MenuComponent: MenuComponent };
}
function getItems(links) {
    var defaultGroup = 'Open in Explore';
    var groups = links.reduce(function (acc, l) {
        var group;
        var title;
        if (l.title.indexOf('/') !== -1) {
            group = l.title.split('/')[0];
            title = l.title.split('/')[1];
            acc[group] = acc[group] || [];
            acc[group].push({ l: l, newTitle: title });
        }
        else {
            acc[defaultGroup] = acc[defaultGroup] || [];
            acc[defaultGroup].push({ l: l });
        }
        return acc;
    }, {});
    return Object.keys(groups).map(function (key) {
        return {
            label: key,
            items: groups[key].map(function (link) { return ({
                label: link.newTitle || link.l.title,
                url: link.l.href,
                onClick: link.l.onClick,
            }); }),
        };
    });
}
function NodeHeader(props) {
    var index = props.node.dataFrameRowIndex;
    var fields = getNodeFields(props.nodes);
    return (React.createElement("div", null,
        fields.title && React.createElement(Label, { field: fields.title, index: index }),
        fields.subTitle && React.createElement(Label, { field: fields.subTitle, index: index }),
        fields.details.map(function (f) { return (React.createElement(Label, { key: f.name, field: f, index: index })); })));
}
function EdgeHeader(props) {
    var index = props.edge.dataFrameRowIndex;
    var fields = getEdgeFields(props.edges);
    return (React.createElement("div", null, fields.details.map(function (f) { return (React.createElement(Label, { key: f.name, field: f, index: index })); })));
}
export var getLabelStyles = stylesFactory(function (theme) {
    return {
        label: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      label: Label;\n      line-height: 1.25;\n      margin: ", ";\n      padding: ", ";\n      color: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    "], ["\n      label: Label;\n      line-height: 1.25;\n      margin: ", ";\n      padding: ", ";\n      color: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n    "])), theme.spacing.formLabelMargin, theme.spacing.formLabelPadding, theme.colors.textFaint, theme.typography.size.sm, theme.typography.weight.semibold),
        value: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      label: Value;\n      font-size: ", ";\n      font-weight: ", ";\n      color: ", ";\n      margin-top: ", ";\n      display: block;\n    "], ["\n      label: Value;\n      font-size: ", ";\n      font-weight: ", ";\n      color: ", ";\n      margin-top: ", ";\n      display: block;\n    "])), theme.typography.size.sm, theme.typography.weight.semibold, theme.colors.formLabel, theme.spacing.xxs),
    };
});
function Label(props) {
    var field = props.field, index = props.index;
    var value = field.values.get(index) || '';
    var styles = getLabelStyles(useTheme());
    return (React.createElement("div", { className: styles.label },
        React.createElement("div", null, field.config.displayName || field.name),
        React.createElement("span", { className: styles.value }, value)));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=useContextMenu.js.map